<div class="status-bar-colored-top"></div>
<div class="status-bar-colored-bottom"></div>

<div class="padding-safe-top full-size-safe-scrollable" [ngClass]="chordsThemeClass()"
     appScrollContainer="chords"
     (dblclick)="onContentDblClick($event)"
     (touchend)="onContentTouchEnd($event)"
     swipeGesture [axis]="'x'" (swipeleft)="onSwipeNext()" (swiperight)="onSwipePrevious()"
     appPinchZoom
     [minZoom]="fontSizeMin"
     [maxZoom]="fontSizeMax"
     [currentZoom]="fontSize"
     (zoomChange)="previewFontSize($event)"
     (zoomEnd)="updateFontSize($event)">
  <div *ngIf="hymn" style="position: relative; display: flex; flex-direction: column;">

    <mat-toolbar color="primary" class="sticky-toolbar-router">
      @if (!sidenavService.hymnListOpen) {
        <div class="padding-safe-left"></div>
      }

      <button (click)="sidenavService.toggleList()" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>

      <span [matMenuTriggerFor]="hymnInfoMenu" class="title-ellipsis">
        {{ translation.hymn + " " + hymn.hymnNumber + " - " + hymn.title }}
      </span>

      <mat-menu #hymnInfoMenu="matMenu">
        <button mat-menu-item>
          <span>{{ translation.hymn + " " + hymn.hymnNumber + " - " + hymn.title }}</span>
        </button>
      </mat-menu>

      <span class="toolbar-fill-remaining-space"></span>

      <button *ngIf="settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)"
              (click)="settingService.removeHymnFromFavoritesAndToLearn(hymn);" mat-icon-button>
        <mat-icon *ngIf="settingService.isFavorite(hymn.hymnNumber)">favorite</mat-icon>
        <mat-icon *ngIf="settingService.isHymnToLearn(hymn.hymnNumber)">bookmark</mat-icon>
      </button>

      <button *ngIf="!settingService.isFavoriteOrHymnToLearn(hymn.hymnNumber)"
              [matMenuTriggerFor]="favoriteMenu" mat-icon-button>
        <mat-icon>favorite_border</mat-icon>
      </button>

      <mat-menu #favoriteMenu="matMenu">
        <button (click)="settingService.toggleFavorite(hymn);" mat-menu-item>
          <mat-icon>favorite_border</mat-icon>
          <span>{{ translation.add_to_favorites }}</span>
        </button>
        <button (click)="settingService.toggleHymnToLearn(hymn);" mat-menu-item>
          <mat-icon>bookmark_border</mat-icon>
          <span>{{ translation.add_to_hymns_to_learn }}</span>
        </button>
      </mat-menu>

      <button mat-icon-button (click)="hymnSelectionService.dialpad()">
        <mat-icon>dialpad</mat-icon>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="shuffleMenu">
        <mat-icon>shuffle</mat-icon>
      </button>

      <mat-menu #shuffleMenu="matMenu">
        <button [disabled]="settingService.getFavorites().length < 2" mat-menu-item (click)="hymnSelectionService.goToRandomHymn(true)">
          <mat-icon>shuffle</mat-icon>
          <span>{{translation.random_favorite}}</span>
        </button>
        <button mat-menu-item (click)="hymnSelectionService.goToRandomHymn(false)">
          <mat-icon>shuffle</mat-icon>
          <span>{{translation.random_hymn}}</span>
        </button>
      </mat-menu>

      @if(!layoutService.isNarrow()) {
        <button mat-icon-button [matMenuTriggerFor]="viewModeMenu">
          <mat-icon>menu_book</mat-icon>
        </button>

        <mat-menu #viewModeMenu="matMenu">
          <button (click)="settingService.setHymnViewMode()" [routerLink]="['/'+translation.path_hymn, hymn.hymnNumber]" mat-menu-item>
            <mat-icon>menu_book</mat-icon>
            <span>{{translation.read_mode}}</span>
          </button>
          <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_sheet_music, hymn.hymnNumber]" mat-menu-item>
            <mat-icon svgIcon="bass-clef"></mat-icon>
            <span>{{translation.sheet_music_mode}}</span>
          </button>
          <button (click)="settingService.setPresentationViewMode()" [routerLink]="['/'+translation.path_present, hymn.hymnNumber]" mat-menu-item>
            <mat-icon>tv</mat-icon>
            <span>{{translation.presentation_mode}}</span>
          </button>
        </mat-menu>

        <span class="toolbar-separator"></span>

        <button mat-icon-button [matMenuTriggerFor]="chordsThemeMenu" aria-label="Theme mode">
          <mat-icon>brightness_6</mat-icon>
        </button>
        <mat-menu #chordsThemeMenu="matMenu">
          <button mat-menu-item (click)="setChordsThemeMode('white')">
            <mat-icon>{{ chordsThemeMode === 'white' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>White</span>
          </button>
          <button mat-menu-item (click)="setChordsThemeMode('day')">
            <mat-icon>{{ chordsThemeMode === 'day' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>Day</span>
          </button>
          <button mat-menu-item (click)="setChordsThemeMode('night')">
            <mat-icon>{{ chordsThemeMode === 'night' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>Night</span>
          </button>
          <button mat-menu-item (click)="setChordsThemeMode('black')">
            <mat-icon>{{ chordsThemeMode === 'black' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
            <span>Black</span>
          </button>
        </mat-menu>
      }

      <!-- Font size (desktop toolbar) -->
      @if(!layoutService.isNarrow()) {
        <button mat-icon-button (click)="changeFontSize()" aria-label="Change font size">
          <mat-icon>text_fields</mat-icon>
        </button>
      }

      <!-- Transpose controls (desktop toolbar) -->
      @if(!layoutService.isNarrow()) {
        <button mat-icon-button [matMenuTriggerFor]="transposeMenu" aria-label="Transpose">
          <mat-icon *ngIf="transposeSteps === 0" svgIcon="sharp"></mat-icon>
          <div *ngIf="transposeSteps !== 0" style="font-size: 0.9rem!important;">{{ formatTranspose(transposeSteps) }}</div>
        </button>
        <mat-menu #transposeMenu="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>tune</mat-icon>
            <span>Transpose: {{ transposeSteps > 0 ? '+' + transposeSteps : transposeSteps }} semitones</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="transposeDown()">
            <mat-icon>arrow_downward</mat-icon>
            <span>Down (-1)</span>
          </button>
          <button mat-menu-item (click)="transposeUp()">
            <mat-icon>arrow_upward</mat-icon>
            <span>Up (+1)</span>
          </button>
          <button mat-menu-item (click)="resetTranspose()">
            <mat-icon>restart_alt</mat-icon>
            <span>Reset</span>
          </button>
        </mat-menu>
      }

      <button mat-icon-button [matMenuTriggerFor]="presentMenu">
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #presentMenu="matMenu">

        @if(layoutService.isNarrow()) {
          <button mat-menu-item [matMenuTriggerFor]="viewModeMenu">
            <mat-icon>menu_book</mat-icon>
            <span>View Mode</span>
          </button>

          <mat-menu #viewModeMenu="matMenu">
            <button (click)="settingService.setHymnViewMode()" [routerLink]="['/'+translation.path_hymn, hymn.hymnNumber]" mat-menu-item>
              <mat-icon>menu_book</mat-icon>
              <span>{{translation.read_mode}}</span>
            </button>
            <button (click)="settingService.setSheetMusicViewMode()" [routerLink]="['/'+translation.path_sheet_music, hymn.hymnNumber]" mat-menu-item>
              <mat-icon svgIcon="bass-clef"></mat-icon>
              <span>{{translation.sheet_music_mode}}</span>
            </button>
            <button (click)="settingService.setPresentationViewMode()" [routerLink]="['/'+translation.path_present, hymn.hymnNumber]" mat-menu-item>
              <mat-icon>tv</mat-icon>
              <span>{{translation.presentation_mode}}</span>
            </button>
          </mat-menu>

          <button mat-menu-item [matMenuTriggerFor]="chordsThemeMenuNarrow" aria-label="Theme mode">
            <mat-icon>brightness_6</mat-icon>
            <span>Day/Night Mode</span>
          </button>
          <mat-menu #chordsThemeMenuNarrow="matMenu">
            <button mat-menu-item (click)="setChordsThemeMode('white')">
              <mat-icon>{{ chordsThemeMode === 'white' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
              <span>White</span>
            </button>
            <button mat-menu-item (click)="setChordsThemeMode('day')">
              <mat-icon>{{ chordsThemeMode === 'day' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
              <span>Day</span>
            </button>
            <button mat-menu-item (click)="setChordsThemeMode('night')">
              <mat-icon>{{ chordsThemeMode === 'night' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
              <span>Night</span>
            </button>
            <button mat-menu-item (click)="setChordsThemeMode('black')">
              <mat-icon>{{ chordsThemeMode === 'black' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
              <span>Black</span>
            </button>
          </mat-menu>

          <button (click)="changeFontSize()" mat-menu-item>
            <mat-icon>text_fields</mat-icon>
            <span>{{translation.change_font_size}}</span>
          </button>

          <button mat-menu-item [matMenuTriggerFor]="transposeMenuNarrow">
            <mat-icon *ngIf="transposeSteps === 0" svgIcon="sharp"></mat-icon>
            <div *ngIf="transposeSteps !== 0" style="font-size: 0.9rem!important; margin-right: 16px;">{{ formatTranspose(transposeSteps) }}</div>
            <span>Transpose</span>
          </button>
          <mat-menu #transposeMenuNarrow="matMenu">
            <button mat-menu-item disabled>
              <mat-icon>tune</mat-icon>
              <span>Current: {{ transposeSteps > 0 ? '+' + transposeSteps : transposeSteps }} st</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="transposeDown()">
              <mat-icon>arrow_downward</mat-icon>
              <span>Down (-1)</span>
            </button>
            <button mat-menu-item (click)="transposeUp()">
              <mat-icon>arrow_upward</mat-icon>
              <span>Up (+1)</span>
            </button>
            <button mat-menu-item (click)="resetTranspose()">
              <mat-icon>restart_alt</mat-icon>
              <span>Reset</span>
            </button>
          </mat-menu>

        }

        <button *ngIf="layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareHymn(this.hymn)">
          <mat-icon>share</mat-icon>
          <span>{{translation.share_hymn + " " + hymn.hymnNumber}}</span>
        </button>

        <button mat-menu-item *ngIf="layoutService.fullscreenSupported()" (click)="layoutService.toggleFullScreen()">
          <mat-icon *ngIf="!layoutService.fullscreen">fullscreen</mat-icon>
          <mat-icon *ngIf="layoutService.fullscreen">fullscreen_exit</mat-icon>
          <span>{{layoutService.fullscreen? translation.fullscreen_exit : translation.fullscreen}}</span>
        </button>


        <button (click)="toggleSettingSidenav()" mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>{{translation.settings}}</span>
        </button>

        <button *ngIf="!layoutService.isNarrow() && layoutService.isNotBrowser()" mat-menu-item (click)="shareService.shareApp();">
          <mat-icon>share</mat-icon>
          <span>{{translation.share_app}}</span>
        </button>
      </mat-menu>

      @if (!settingService.settingsOpened) {
        <div class="padding-safe-right"></div>
      }
    </mat-toolbar>

    <div id="hymn-scroll-container"
         class="chord-content-container"
         [ngClass]="chordsThemeClass()"
         [style.width.%]="layoutService.isNarrow() ? 100 : null"
         [style.min-width.px]="!layoutService.isNarrow() ? layoutService.narrowWidthThreshold : null">

      <div *ngIf="isLoading" class="centered-state">
        <div class="spinner-container">
          <p>Loading chords...</p>
        </div>
      </div>

      @if (!isLoading && isAvailable && renderedHtml) {
        <div class="chord-render-area"
             [ngClass]="chordsThemeClass()"
             [style.font-size.px]="fontSize"
             [style.font-family]="chordsFontFamily || null"
             [style.font-weight]="chordsFontWeight || null"
             [innerHTML]="renderedHtml">
        </div>
      }

      <div *ngIf="!isLoading && !isAvailable" class="centered-state error-state">
        <mat-icon style="font-size: 64px; height: 64px; width: 64px; opacity: 0.3;">music_off</mat-icon>
        <h3>{{ translation.chords_not_available }}</h3>
        <p>There is no chord file found for Hymn {{ hymn.hymnNumber }}.</p>
      </div>

      @if (!isLoading && isAvailable && renderedHtml) {
        <span class="credit">Chords by <a style="color: var(--primary-background)" href="https://bradwarden.com/music/hymnchords/" target="_blank">bradwarden.com</a></span>
      }

    </div>

    <app-music-control [autoscrollVisible]="true" [karaokeAvailable]="false" class="music-control-menu"></app-music-control>
  </div>
</div>
